import PropTypes from 'prop-types';
import { SURVEY_TYPES } from '../../../services/utilityFunctions';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import SurveyQuestionProp from './surveyQuestionProp';

const propType = {
  _id: PropTypes.string,
  type: PropTypes.oneOf(SURVEY_TYPES),
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.shape(ImageProp.propType),
    PropTypes.string,
  ]),
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  isSubmitted: PropTypes.bool,
  submittedDate: PropTypes.number,
  journeyAssigned: PropTypes.bool,
  questions: PropTypes.arrayOf(PropTypes.shape(SurveyQuestionProp.propType)),
};

export default { propType };
